export const UsersRoutes = [
  {
    path: "users",
    name: "users",
    component: () => import("@/domain/Users/presentation/pages/UsersListPage.vue"),
    meta: { requiresAuth: true, permissions: "users.read" },
  },
  {
    path: "users/:id",
    name: "editUser",
    component: () => import("@/domain/Users/presentation/pages/UserDetailPage.vue"),
    meta: { requiresAuth: true, permissions: "users.read" },
  },
];
